module.exports = __webpack_public_path__ + "static/media/YB5F06_3.38279359.jpg";